import moment from "moment";

import { createListBetweenTwoNumbers } from "../../utils/helperFunctions";
import { EXPRESS_TYPES, SERVICE_TYPES, DELIVERY_TYPES, AREA_POS_MAPPING_TYPE } from "./../../config/constants";
import { isArrayValid, isEmptyOrNull, isUndefined } from "../../utils/DataUtils";

// Tab list for cuntry setting

export const ServiceTypeTabList: Array<any> = [
  { serviceTypeLabel: "Standard", serviceType: SERVICE_TYPES.STANDARD, countKey: "standard", countStyle: "standardServiceTypeCount" },
  { serviceTypeLabel: "Express", serviceType: SERVICE_TYPES.EXPRESS, countKey: "express", countStyle: "expressServiceTypeCount" },
  { serviceTypeLabel: "Click & Collect", serviceType: SERVICE_TYPES.CLICK_N_COLLECT, countKey: "cnc", countStyle: "cncServiceTypeCount", hideDivisonView: true },
  { serviceTypeLabel: "Default", serviceType: SERVICE_TYPES.DEFAULT, countKey: "default", countStyle: "defaultServiceTypeCount" },
  { serviceTypeLabel: "FBC", serviceType: SERVICE_TYPES.FBC, countKey: "fbc", countStyle: "fbcServiceTypeCount" },
];

interface Holiday {
  dateLabel: string;
  offDay: string;
  offDate: string;
  active: boolean;
}

const createHolidayObjects = (info: any) => {
  const holidaysList = getHolidaysListObject(info);
  return holidaysList.map((item: { objectDate: string }) => ({ offDay: "", offDate: item.objectDate, active: true }));
};

const getHolidaysArray = (data: any) => {
  let calendarHoliday: Holiday[] = [];
  let weeklyholiday: Holiday[] = [];

  if (!isUndefined(data.holidays) && isArrayValid(data.holidays)) {
    calendarHoliday = data.holidays.flatMap((info: any) => {
      if (info.dateLabel) {
        return createHolidayObjects(info);
      } else if (!info.hasOwnProperty("offDay")) {
        return { offDay: "", offDate: info.offDate, active: true };
      } else {
        return [];
      }
    });
  }

  if (!isUndefined(data.weeklyHolidays) && isArrayValid(data.weeklyHolidays)) {
    weeklyholiday = data.weeklyHolidays.map((info: any) => ({ offDay: info, offDate: "", active: true }));
  }

  return [...calendarHoliday, ...weeklyholiday];
};

export function countrySettingsDetailsPayloadNew(countryName: string, configs: any) {
  const result = Object.keys(configs).map((key) => {
    const { serviceTypeID, advanceSlotDays, nextDaySlotVisibility, bagChargeEnabled, serviceActive, expressType, deliveryType, itemsPerBag, bagCharges, newPlasticBagCharges } = configs[key];
    const itemsPerBagValue = !isEmptyOrNull(newPlasticBagCharges?.itemsPerBag) ? newPlasticBagCharges.itemsPerBag : itemsPerBag;
    const bagChargesValue = !isEmptyOrNull(newPlasticBagCharges?.bagCharges) ? newPlasticBagCharges.bagCharges : bagCharges;
    return {
      serviceTypeID,
      advanceSlotDays: !isEmptyOrNull(configs[key]?.editSlotDays) ? configs[key].editSlotDays : advanceSlotDays,
      nextDaySlotVisibility,
      bagChargeEnabled,
      serviceActive: serviceActive,
      ...(!isEmptyOrNull(bagChargesValue) && { bagCharges: bagChargesValue }),
      ...(!isEmptyOrNull(itemsPerBagValue) && { itemsPerBag: itemsPerBagValue }),
      ...(expressType && { expressType }),
      ...(deliveryType === DELIVERY_TYPES.DAY_BASED && { holidays: getHolidaysArray(configs[key]) }),
    };
  });
  const body = { countryName, serviceTypes: result, areaPosMappingType: AREA_POS_MAPPING_TYPE.POLYGON_BASED };
  return body;
}

export const StandardInitConfig = { serviceTypeID: 1, nextDaySlotVisibility: true, showAdvanceSlotDaysInput: false, advanceSlotDays: 7, editSlotDays: 7, bagChargeEnabled: false, serviceActive: true };
export const ExpressInitConfig = { serviceTypeID: 3, nextDaySlotVisibility: true, expressType: EXPRESS_TYPES.ON_DEMAND.value, showAdvanceSlotDaysInput: false, advanceSlotDays: 2, editSlotDays: 2, bagChargeEnabled: false, serviceActive: true };
export const ClickCollectInitConfig = { serviceTypeID: 4, nextDaySlotVisibility: true, showAdvanceSlotDaysInput: false, advanceSlotDays: 7, editSlotDays: 7, bagChargeEnabled: false, serviceActive: true };
export const DefaultInitConfig = { serviceTypeID: 2, holidays: [], bagChargeEnabled: false, serviceActive: true };
export const FBCInitialConfig = { serviceTypeID: 124124, serviceActive: true };
export const WeeklyHolidayConfig = { holidays: [] };
export const ADVANCE_DAYS_DDN_OPTIONS = createListBetweenTwoNumbers(2, 28);

export function getDateFromPicker(dateData: any) {
  return moment(dateData).format("YYYY-MM-DD");
}

function getDates(startDate: Date, stopDate: Date) {
  const dateArray: any = [];
  const currDate = moment(startDate).startOf("day");
  const lastDate = moment(stopDate).startOf("day");

  if (currDate) {
    const objectDate = moment(currDate.toDate()).format("YYYY-MM-DD");
    dateArray.push({ objectDate });
  }
  while (currDate.add(1, "days").diff(lastDate) <= 0) {
    const objectDate = moment(currDate.toDate()).format("YYYY-MM-DD");
    dateArray.push({ objectDate });
  }
  return dateArray;
}

export function getHolidaysListObject(dateObject: any) {
  if (dateObject?.dateFrom && dateObject?.dateTo) {
    const dateDataArray = getDates(dateObject.dateFrom, dateObject.dateTo);
    return dateDataArray;
  }
  return [];
}

export const COUNTRY_SETTING_TEXT_CONSTANT = {
  REMOVE: "REMOVE",
  ADD: "ADD",
  CANCEL: "CANCEL",
  PROCEED: "PROCEED",
  IS_LOADING: "loading...",
  BAG_CHARGES: "Bag Charges",
  ITEMS_PER_BAG: "Items per bag",
  ADVANCE_SLOT_DAYS: "Advance slot days",
  NEXT_DAY_SLOT_VISIBILITY: "Next day slot visibility",
  EXPRESS_TYPE: "Express type",
  DELIVERY_TYPE: "Delivery type",
  SERVICE_ACTIVE: "Service active",
  HOLIDAYS: "Holidays",
  DEFAULT_POS: "Default POS",
  EDIT_BAG_CHARGE: "Edit bag charge",
  OLDER_DATES: "Older dates",
  DUPLICATE_HOLIDAYS: "Duplicate holidays",
  OLDER_DATE_SELECTED_ERROR: "Please don't use older dates. Use dates tomorrow onwards.",
  DATES_ALREADY_SELECTED_ERROR: "Following dates are already selected as holiday. Please check date range and select appropriately.",
  CONFIRM_EXPRESS_TYPE_CHANGE: "Confirm express type change",
  SLOTS_NEEDS_REVALIDATION: "Slots needs to be re-validated as the express type is changed",
  APPROVE: "Approve",
  COUNTRY_SETTING_LABEL: "Country Setting - ",
  NO_SERVICE_TYPE_SELECTED: "Please select a Service Type from above to view or update configurations.",
  INVALID_INPUT_ITEMS_PER_BAG: "Invalid input for items per bag: must be a whole number",
  INVALID_INPUT_BAG_CHARGES: "Invalid input for bag charges: must be a number with up to 3 decimal places.",
  SUCCESS: "Country Settings saved successfully.",
  ERROR: "Error while creating country settings. Please try again later.",
  UPDATED: "Country Settings updated successfully.",
  ERROR_UPDATING: "Error while updating country settings. Please try again later.",
  CONFIRM_CHANGES: "Are you sure you want to apply the following changes ?",
  AREA_ASSIGNMENT: "Area assignment",
  AREA_BASED_ASSIGNMENT: "Area based assignment",
  POLYGON_BASED_ASSIGNMENT: "Polygon based assignment",
  CALENDAR_HOLIDAYS: "Calendar holidays",
  WEEKLY_HOLIDAYS: "Weekly holidays",
  ENABLE_SERVICE_TYPE: "Enable service type",
  PLASTIC_BAG_CHARGE_ENABLED: "Plastic bag charge enabled",
  NUMBER_OF_ITEMS_PER_BAG: "Number of items per bag",
  PRICE_PER_BAG: "Price per bag",
  PLASTIC_BAG_CHARGE: "Plastic bag charges",
  EDITED_ADVANCE_SLOT_DAYS: "Edited advance slot days",
  SERVICE_TYPE: "Service type",
  KEY_EXPRESS_TYPE: "expressType",
  KEY_HOLIDAYS: "holidays",
  KEY_WEEKLY_HOLIDAYS: "weeklyHolidays",
  KEY_STANDARD_NEXT_DAYS_SLOT_VISIBILITY: "standardNextDaySlotVisibility",
  EDIT_DAYS: "Edit days",
  SELECT_MAPPING_TYPE: "Select the Mapping Type"
}

export interface CalendarHolidayInterface {
  dateLabel: string;
  offDay: string;
  offDate: string;
  active: boolean;
}

export interface DefaultBaseConfig {
  nextDaySlotVisibility: boolean;
  bagChargeEnabled: boolean;
  serviceActive: boolean;
  defaultPos: object;
  editBagCharge: boolean;
  itemsPerBag: string | number;
  bagCharges: string | number;
  newPlasticBagCharges: { itemsPerBag: string | number, bagCharges: string | number };
}

export interface DayBasedConfigInterface extends DefaultBaseConfig {
  showAdvanceSlotDaysInput: boolean;
  advanceSlotDays: number;
  editSlotDays: number | string;
  holidays: string[];
  weeklyHolidays: string[];
  deliveryType: typeof DELIVERY_TYPES[keyof typeof DELIVERY_TYPES];
}

export interface MinuteBasedConfigInterface extends DefaultBaseConfig {
  showAdvanceSlotDaysInput: boolean;
  advanceSlotDays: number;
  editSlotDays: number | string;
  expressType: typeof EXPRESS_TYPES[keyof typeof EXPRESS_TYPES]['value'];
  deliveryType: typeof DELIVERY_TYPES[keyof typeof DELIVERY_TYPES];
}

export type ServiceConfigInterface = DayBasedConfigInterface | MinuteBasedConfigInterface | SlotBasedConfigInterface;
export type ConfigInterface = Record<string, ServiceConfigInterface>;

export interface SlotBasedConfigInterface extends DefaultBaseConfig {
  showAdvanceSlotDaysInput: boolean;
  advanceSlotDays: number;
  editSlotDays: number | string;
  deliveryType: typeof DELIVERY_TYPES[keyof typeof DELIVERY_TYPES];
}

const DEFAULT_BASE_OBJ: DefaultBaseConfig = {
  nextDaySlotVisibility: false,
  serviceActive: true,
  defaultPos: {},
  bagChargeEnabled: false,
  editBagCharge: false,
  itemsPerBag: "",
  bagCharges: "",
  newPlasticBagCharges: { itemsPerBag: "", bagCharges: "" },
};

export const DEFAULT_DAY_BASED_OBJ: DayBasedConfigInterface = Object.freeze({
  ...DEFAULT_BASE_OBJ,
  showAdvanceSlotDaysInput: false,
  advanceSlotDays: 0,
  editSlotDays: "",
  holidays: [],
  weeklyHolidays: [],
  deliveryType: DELIVERY_TYPES.DAY_BASED,
});

export const DEFAULT_MINUTE_BASED_OBJ: MinuteBasedConfigInterface = Object.freeze({
  ...DEFAULT_BASE_OBJ,
  showAdvanceSlotDaysInput: false,
  advanceSlotDays: 2,
  editSlotDays: "",
  expressType: EXPRESS_TYPES.ON_DEMAND.value,
  deliveryType: DELIVERY_TYPES.MINUTE_BASED,
});

export const DEFAULT_SLOT_BASED_OBJ: SlotBasedConfigInterface = Object.freeze({
  ...DEFAULT_BASE_OBJ,
  showAdvanceSlotDaysInput: false,
  advanceSlotDays: 2,
  editSlotDays: "",
  deliveryType: DELIVERY_TYPES.SLOT_BASED,
});
